import { RadioButton } from '@lt/components';
import { useTranslation } from '@lt/localization';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import VisaServiceLabelContainer from '../../../../components/Tourists/VisaServiceLabelContainer';
import { VISA_SERVICES } from '../../store/domains/visa';

const baseCls = 'tourists-form__visa';

const VisaServiceOptions = ({ idx, visaServices, value, onChange }) => {
  const { t } = useTranslation();
  if (!visaServices) {
    return null;
  }
  return (
    <div className={baseCls}>
      <div className={`${baseCls}--title`}>
        {t('checkout.touristForm.visaService.options')}
      </div>
      {visaServices.map((visaService) => {
        const { id } = visaService;
        const elId = `visa_support-${idx}--${id}`;
        const selected = value === id;
        return (
          <label
            key={elId}
            id={`${elId}-label`}
            className={cn(`${baseCls}--label`, {
              [`${baseCls}--label-selected`]: selected,
            })}
            htmlFor={elId}
          >
            <RadioButton
              id={elId}
              name={`visa_support-${idx}`}
              value={id}
              checked={selected}
              onChange={() => onChange(id)}
              className="checkout-radiobutton"
            />
            <VisaServiceLabelContainer
              serviceItem={visaService}
              className={baseCls}
            />
          </label>
        );
      })}
    </div>
  );
};

VisaServiceOptions.propTypes = {
  idx: PropTypes.string.isRequired,
  visaServices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.oneOf(
    Object.keys(VISA_SERVICES).map(
      (serviceType) => VISA_SERVICES[serviceType].id,
    ),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default VisaServiceOptions;
